{
    "Monday": "Montag",
    "Mondayshort": "Mo",
    "Tuesday": "Dienstag",
    "Tuesdayshort": "Di",
    "Wednesday": "Mittwoch",
    "Wednesdayshort": "Heiraten",
    "Thursday": "Donnerstag",
    "Thursdayshort": "Do",
    "Friday": "Freitag",
    "Fridayshort": "Fr",
    "Saturday": "Samstag",
    "Saturdayshort": "Sa",
    "Sunday": "Sonntag",
    "Sundayshort": "Sonne",
    "NAME": "DaysOfTheWeek"
}